export default "__VITE_ASSET__B0LPJ9B1__"